import { Injectable } from '@angular/core';
import { PreRequestProductApi } from 'src/app/core/http/entidades/PreRequestProductApi';

@Injectable({
  providedIn: 'root'
})
export class PrerequestproductService {

  constructor(private api: PreRequestProductApi) {
    this.api.baseName = 'prerequestproduct';
  }
  /** buscar todas os segmentos */
  getall(): any {
    return new Promise((resolve, reject) => {
      this.api.get()
        .then(data => resolve(data))
        .catch(error => reject(error));
    });
  }
  /** buscar um segmento pelo Id */
  get(id: number): any {
    return new Promise((result, reject) => {
      this.api.getOne(id.toString())
        .then(data => result(data))
        .catch(error => reject(error));
    });
  }

  /** Salvar */
  save(request: any): any {
    return new Promise((resolve, reject) => {
      // se segmento novo, insere
      if (!request.preRequestProductId) {
        this.api.post(request)
          .then((data: any) => resolve(data))
          .catch(() => {
            reject();
          });
      } else { // senão atualiza
        this.api.put(request)
          .then((data: any) => resolve(data))
          .catch(() => {
            reject();
          });
      }
    });
  }
  /** excluir */
  delete(id: number): any {
    return new Promise((resolve, reject) => {
      this.api.delete(id)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
}
